export const locales = ['en', 'fr', 'ar'];
